import { Input } from "antd";
import React from "react";
import { EMPTY_VALUE } from "../../../../utils/format";

const TEXTAREA_AUTO_SIZE = { minRows: 2, maxRows: 8 };

const SaleInfoField = ({ label, value, uppercase, multiline }) => {
  const isEmpty = value === null || value === undefined || value === "";
  const Field = multiline ? Input.TextArea : Input;
  return (
    <div>
      <p>{label}</p>
      <Field
        readOnly
        aria-label={label}
        style={uppercase ? { textTransform: "uppercase" } : undefined}
        value={isEmpty ? EMPTY_VALUE : value}
        {...(multiline ? { autoSize: TEXTAREA_AUTO_SIZE } : {})}
      />
    </div>
  );
};

export default SaleInfoField;
